import { render, staticRenderFns } from "./GiftCardSettings.vue?vue&type=template&id=6b5cf6b0&"
import script from "./GiftCardSettings.vue?vue&type=script&lang=ts&"
export * from "./GiftCardSettings.vue?vue&type=script&lang=ts&"
import style0 from "./GiftCardSettings.vue?vue&type=style&index=0&id=6b5cf6b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports